module.exports = __webpack_public_path__ + "img/hcalc1.e98a2dc7.png";